import { Spin } from "antd";
import type { ReactNode } from "react";

import { useOssSignedUrl } from "@/hooks/useOssSignedUrl";
import { cn } from "@/lib/cn";

/** OSS 私有文件预览图 props */
export interface OssPreviewImageProps {
  /** 业务库 OSS 公网 URL */
  fileUrl?: string;
  /** 图片 alt 文案 */
  alt?: string;
  /** img 样式类名 */
  className?: string;
  /** 无 URL 或换取签名失败时的占位 */
  fallback?: ReactNode;
  /** 是否发起换取请求，默认 true */
  enabled?: boolean;
}

/**
 * OSS 私有文件预览图
 * 通过 access-url 接口换取短时签名 URL 后再渲染 img
 */
export const OssPreviewImage = ({
  fileUrl,
  alt,
  className,
  fallback = null,
  enabled = true,
}: OssPreviewImageProps) => {
  const { signedUrl, loading, error } = useOssSignedUrl({
    fileUrl,
    enabled: enabled && !!fileUrl,
  });
  // 无原始 URL 时直接展示占位
  if (!fileUrl) return <>{fallback}</>;
  return (
    <Spin
      spinning={loading}
      wrapperClassName="block h-full w-full [&_.ant-spin-container]:relative [&_.ant-spin-container]:h-full [&_.ant-spin-container]:w-full"
    >
      {signedUrl ? (
        <img
          src={signedUrl}
          alt={alt}
          className={cn("block h-full w-full object-cover", className)}
        />
      ) : !loading && error ? (
        fallback
      ) : null}
    </Spin>
  );
};
